import React from "react";
import { View, Text, StyleSheet, TouchableOpacity, ActivityIndicator, Linking,
	Dimensions, Image, AsyncStorage, Platform } from "react-native";
import { color } from "../config/color"
import store from "../config/config.json"
import Main from "../widgets/Main";
import GlowOpacity from "../widgets/GlowOpacity";
import MainComponent from "../utilities/MainComponent";
import * as Font from 'expo-font';
import i18n from 'i18n-js';
import AppContext from "../utilities/AppContext"

export default class FailureScreen extends MainComponent {	
	
	state = {
		store : {},
		isLoading: false,
		orderData: undefined,
		showFullMode 	: true,
	};
	
	static navigationOptions = {
		headerShown: false
	};

	constructor(props) {
		super(props);

		this.state.showError = false
		
		let screenWidth   = window.innerWidth;
		let screenHeight  = window.innerHeight;
		
		this.state.height = screenHeight
		this.state.width = screenWidth
		this.state.totalPrice = 0

		if(screenWidth < color.screenLimit){
			this.state.showFullMode = false;			
		}else{
			this.state.showFullMode = true;			
		}
	}

	componentDidMount() {	

		Dimensions.addEventListener('change', (e) => {
			const { width, height } = e.window;
			this.setState({height: height, width: width})
			if(width < color.screenLimit){
				this.setState({showFullMode: false});			
			}else{
				this.setState({showFullMode: true});			
			}
		})

		let params = this.props.navigation.state.params
		if(params.paymentId != undefined){
			
		}
		else 
			this.props.navigation.navigate("menu")

		this.getDetails()
	}


	callOnPhone = async () => {
		var str = this.state.store.phone;
		var phoneString = str.replace(/-/g, "");
		const url = `tel:${phoneString}`;

		Linking.canOpenURL(url)
			.then((supported) => {
				if (supported) {
					return Linking.openURL(url)
						.catch(() => null);
				}
			});
	}

	getDetails = async () => {		
		
		await Font.loadAsync(color.appFonts);
		try {

            var value = await AsyncStorage.getItem(store.storeData)
			if (value == undefined)
				value = {}
			else
			{
				value = JSON.parse(value)			
	            this.setState({store: value})
			}
        } catch (error) {
            console.log(error)
        }
	}
	
	onSubmit = async () => {
		try {
			//await AsyncStorage.clear()
			this.props.navigation.navigate('checkout')
		} catch (error) {
		}
	}

	/****
	 * 
	 * 
	 * 
	 * 
	 * 
	 */
	
	// List View 
	renderDetails(){
		var height = 3
		var orderId = ""
		if(this.state.orderData != undefined)
		 	orderId = this.state.orderData.orderId.slice(0, 4) + "-" + this.state.orderData.orderId.slice(4);

		return (
			<View style={styles.container}>				
				<View>
					<View style={{ marginTop: 20, justifyContent: "center", alignContent: "center", alignItems: "center"}}>
					
								<div style={{width: 155, height: 155}}>

								<svg xmlns="http://www.w3.org/2000/svg" width="169" height="155" viewBox="0 0 521 479">
										<defs>
											<clipPath id="clip-Unsuccessful">
											<rect width="521" height="479"/>
											</clipPath>
										</defs>
										<g id="Unsuccessful" clipPath="url(#clip-Unsuccessful)">
											<g id="pay" transform="translate(41 42.999)">
											<path id="Subtraction_1" data-name="Subtraction 1" d="M-4460.216,174.382a23.532,23.532,0,0,1-6.675-1.458,82.364,82.364,0,0,1-10.477-4.461,137.327,137.327,0,0,1-27.4-18.447A141.023,141.023,0,0,1-4532.494,118a132.473,132.473,0,0,1-18.125-46.616A146.826,146.826,0,0,1-4553,44.793V-3.982c8.189-2.225,16.366-4.738,24.3-7.471,7.905-2.722,15.811-5.744,23.5-8.982A386.212,386.212,0,0,0-4460.216-43a386.152,386.152,0,0,0,45.652,22.733A380.78,380.78,0,0,0-4367.43-3.982V44.792a146.912,146.912,0,0,1-2.38,26.6A132.473,132.473,0,0,1-4387.936,118a141.035,141.035,0,0,1-27.726,32.013,137.335,137.335,0,0,1-27.4,18.447,82.409,82.409,0,0,1-10.478,4.461A23.541,23.541,0,0,1-4460.216,174.382Zm-1-90.448h0l21.24,21.24a8.526,8.526,0,0,0,6.068,2.514,8.53,8.53,0,0,0,6.071-2.514,8.6,8.6,0,0,0,0-12.14l-21.241-21.24,21.239-21.24a8.594,8.594,0,0,0,0-12.138,8.53,8.53,0,0,0-6.07-2.514,8.53,8.53,0,0,0-6.07,2.514l-21.24,21.238-21.24-21.238a8.524,8.524,0,0,0-6.068-2.514,8.529,8.529,0,0,0-6.07,2.514,8.524,8.524,0,0,0-2.515,6.069,8.527,8.527,0,0,0,2.515,6.07l21.238,21.24-21.239,21.24a8.526,8.526,0,0,0-2.515,6.069,8.527,8.527,0,0,0,2.513,6.069,8.527,8.527,0,0,0,6.069,2.514,8.521,8.521,0,0,0,6.068-2.514l21.242-21.239Z" transform="translate(4763.972 237.86)" fill="#0369b8"/>
											<g id="Group_22" data-name="Group 22" transform="translate(8.583 34.584)">
												<rect id="Rectangle_3" data-name="Rectangle 3" width="421" height="51" transform="translate(0.417 51.417)" fill={store.primaryColor}/>
												<path id="Path_79" data-name="Path 79" d="M110.081,276.044a30.025,30.025,0,1,0-15.021,26.024A30.021,30.021,0,0,0,110.081,276.044Z" transform="translate(-15.667 -65.755)" fill={store.primaryColor}/>
												<path id="Path_80" data-name="Path 80" d="M102.5,250.021a30.052,30.052,0,0,1,0,52.045,30.042,30.042,0,1,0,0-52.045Z" transform="translate(-23.106 -65.755)" fill="none"/>
											</g>
											<path id="Path_84" data-name="Path 84" d="M413.816,26H25.642A25.671,25.671,0,0,0,0,51.643V292.186A25.672,25.672,0,0,0,25.642,317.83h180.75a143.463,143.463,0,0,0,40.131,70.09c22.1,21.472,47.44,32.907,57.234,32.907s35.13-11.436,57.233-32.907a143.463,143.463,0,0,0,40.132-70.09h12.694a25.672,25.672,0,0,0,25.642-25.644V51.643A25.673,25.673,0,0,0,413.816,26ZM17.166,94.666H422.292V129H17.166Zm8.476-51.5H413.816a8.486,8.486,0,0,1,8.476,8.476V77.5H17.166V51.643A8.486,8.486,0,0,1,25.642,43.167ZM349.571,375.075c-20.773,20.4-42.083,28.341-45.814,28.582-3.732-.241-25.042-8.177-45.815-28.582-17.512-17.2-38.387-47.2-38.387-92.423V240.384a384.244,384.244,0,0,0,84.2-35.615,397.431,397.431,0,0,0,84.2,35.608v42.274C387.959,327.876,367.083,357.874,349.571,375.075Zm64.245-74.412h-9.708a158.385,158.385,0,0,0,1.018-18.01V233.879a8.584,8.584,0,0,0-6.334-8.283,378.779,378.779,0,0,1-90.7-38.14,8.584,8.584,0,0,0-8.672,0,368.343,368.343,0,0,1-90.7,38.14,8.583,8.583,0,0,0-6.333,8.283v48.775a158.185,158.185,0,0,0,1.018,18.01H25.642a8.486,8.486,0,0,1-8.476-8.478V146.165H422.292V292.186A8.487,8.487,0,0,1,413.816,300.663Z" transform="translate(0 0)"/>
											<path id="Path_85" data-name="Path 85" d="M108.663,236a38.674,38.674,0,0,0-15.014,3.042,38.624,38.624,0,1,0,0,71.165A38.623,38.623,0,1,0,108.663,236Zm-51.5,38.624a21.458,21.458,0,1,1,21.459,21.458A21.482,21.482,0,0,1,57.167,274.627Zm53.624,21.351a38.525,38.525,0,0,0,0-42.7,21.457,21.457,0,0,1,0,42.7Z" transform="translate(-5.668 -29.754)"/>
											<path id="Path_86" data-name="Path 86" d="M48.582,208.168H92.731a8.583,8.583,0,1,0,0-17.166H48.582a8.583,8.583,0,0,0,0,17.166Z" transform="translate(-5.667 -23.378)"/>
											<path id="Path_87" data-name="Path 87" d="M129.105,208.168h.407a8.583,8.583,0,1,0,0-17.166h-.407a8.583,8.583,0,1,0,0,17.166Z" transform="translate(-17.076 -23.378)"/>
											</g>
										</g>
										</svg>

								</div>


								<Text style={{ fontFamily: 'main-regular', color: 'black', marginTop: 15, fontSize:18}}>{i18n.t("failed")}</Text>		
								<Text style={{ fontFamily: 'main-regular', color:color.detailsColor, marginTop: 10, fontSize:14}}>{i18n.t("failedText")}</Text>		
					</View>

					<GlowOpacity 
						glowColor={this.state.store.primaryColor}
						style={{marginTop: 90, marginLeft: 15, marginRight: 15, borderColor: color.lightGray, borderRadius: store.buttonCorner, borderWidth: 1, backgroundColor:'white'}}
						onPress={() => { this.callOnPhone() }}
					>
						<View style={{justifyContent: "center", height: 34, alignItems: "center", alignContent: "center"}}>
							<Text style={{ fontFamily: 'main-bold', color: 'black', fontSize: 12, textAlign: "center"}}>{i18n.t("getHelp")}</Text>
						</View>								
					</GlowOpacity>
					
					<View style={{marginTop: 40, height: 65, marginTop: "auto", backgroundColor:"white", justifyContent: "center"}}>
				
					<TouchableOpacity style={{marginLeft: 10, marginRight: 10, marginBottom: 10, marginTop: "auto", height:48, justifyContent: "center"}}
										onPress={() => { this.onSubmit() }}
								>
						<View style={{justifyContent: "center", alignItems: "center", flex:1, borderRadius: store.buttonCorner, backgroundColor:this.state.store.primaryColor}}>
							<Text style={{ fontFamily: 'main-regular',color:'#FFF', fontWeight:"bold", fontSize:16}}>{i18n.t("tryAgain")}</Text>		
						</View>

					</TouchableOpacity>

				</View>
				</View>
			</View>
		)
	}

	render() {
		var that = this
		return (
			<AppContext.Consumer>
			{ (context) => (
				<View style={styles.container} ref={(ref) => { 
					this.context = context; 					
				}}>						
					{this.state.showFullMode && (										
						
						<View style={styles.webContainer}>						
							
							<View style={{backgroundColor: color.backgroundColor, height: this.state.height, width: this.state.width * .33}}>

								{that.renderDetails()}

							</View>

							<Main {...this.state} changeMenu={this.changeMenu} />

						</View>					
					)}
					
					{!this.state.showFullMode && !this.state.showMenu && (
						<View style={styles.container}>						
													
							<View style={{backgroundColor: color.backgroundColor, height: this.state.height}}>
								{that.renderDetails()}
							</View>

						</View>
					)}
					
				</View>
			)}
			</AppContext.Consumer>
	  );
	}
}

const styles = StyleSheet.create({
	container: {
		flex: 1,
		backgroundColor: 'white'
	},
	webContainer: {
		flex: 1,
		flexDirection: "row",
	},
	topBar: {
		backgroundColor: "white",
        position: "absolute",
        width: "100%", 
        height: 50,
		flexDirection: "row", 
        alignContent: "center", 
        alignItems: "center"
    }
});